/*
 * @Description: 
 * @Author: kangkang
 * @Date: 2022-06-26 22:24:06
 * @LastEditTime: 2023-04-09 21:06:21
 * @LastEditors: kangkang
 * @Reference: 
 */
import Vue from 'vue'
import Router from 'vue-router'
import moment from 'moment';
import Store from './store/index';
const Example = () => import("./views/example.vue");
import IndexRouter from "./router/index.router";//首页

Vue.use(Router)
const Node_Env_Name =  process.env.NODE_ENV;
const baseName = Node_Env_Name == "development" ? "/dc220813dev/" : "/dc220813/";
const router = new Router({
    base: baseName,
    mode: "hash",
    routes: [
        {
            path: "",
            redirect: "/index",
        },
        {
            path: "/example",
            name: "example",
            meta: {
                name: "example",
                hide: false,
                iconType: "warning"
            },
            component: Example
        }
    ].concat(
       IndexRouter
    )
});

router.beforeEach((to,from,next) => {
    if(sessionStorage.requestTime){
        let storageTime = sessionStorage.requestTime;
        let date = parseInt(moment(new Date()).valueOf() / 1000);
        let expiresIn = sessionStorage.expires_in;//规定token 过期时间
        let diff = date - storageTime * 1;//相差秒数
        if(expiresIn * 1 - diff < 1800){
            Store.dispatch("doGetRefreshToken")
        }
    }
    next();
})
export default router;
